import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import ViewHelper from '../../helpers/ViewHelper';

class Rating extends Component {
  render() {
    let { item, text, settings } = this.props;
    const rating_colors = settings ? JSON.parse(settings.rating_colors) : '';
    let ratingColor = rating_colors[parseInt(ViewHelper.toRating(item.overall_rating))];
    if (this.props.grid_layout === 'old') {
      return (
        <span className="rating-container">
          {item.ratable && item.overall_rating > 0 && (
            <span className="rating badge" style={{ backgroundColor: ratingColor }}>
              <FontAwesomeIcon icon={faStar} size={'sm'} />
              <span className="rating-number">{ViewHelper.toRating(item.overall_rating)}</span>
            </span>
          )}
          {text && (
            <span className="f3 text ml-2" style={{ color: ratingColor }}>
              {text}
            </span>
          )}
        </span>
      );
    } else if (this.props.grid_layout !== '') {
      return (
        <span className="rating-container-custom">
          {item.ratable && item.overall_rating > 0 && (
            <span className={this.props.quick_button && this.props.menu_photo ? `rating badge d-flex align-items-center quick-btn-right quick-rating-right` : this.props.menu_photo ? `rating badge d-flex align-items-center quick-btn-right` : `rating badge d-flex align-items-center`} style={{ backgroundColor: ratingColor }}>
              <FontAwesomeIcon icon={faStar} size={'sm'} />
              <span className="rating-number">{ViewHelper.toRating(item.overall_rating)}</span>
            </span>
          )}
          {text && (
            <span className="f3 text ml-2" style={{ color: ratingColor }}>
              {text}
            </span>
          )}
        </span>
      );
    }
  }
}

export default Rating;
